import { render, staticRenderFns } from "./CompanyPermissions.vue?vue&type=template&id=6ba80e91&"
import script from "./CompanyPermissions.vue?vue&type=script&lang=js&"
export * from "./CompanyPermissions.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports